/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StatusIcon
 *
 * @file StatusIcon.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Icon } from '@greenville/mui-theme';
import { withStyles } from '@material-ui/core/styles';

import ResourceUtils from '../../utils/ResourceUtils';
import StyledCheckBox from './StyledCheckBox';
import {
  BULK_DOWNLOAD_STATUS_COMPLETED,
  BULK_DOWNLOAD_STATUS_INPROGRESS,
  BULK_DOWNLOAD_STATUS_NOT_STARTED,
  BULK_DOWNLOAD_STATUS_REMOVING,
  DOWNLOAD_STATUS_COMPLETED,
  DOWNLOAD_STATUS_DELETING,
  DOWNLOAD_STATUS_ERROR,
  DOWNLOAD_STATUS_INPROGRESS
} from '../../common/constants';

const styles = (theme) => ({
  circularProgress: {
    color: theme.color.activePrimary,
    height: '16px !important',
    width: '16px !important'
  },
  selectedSpan: {
    color: theme.color.activePrimary
  }
});

const StatusIcon = ({
  bulkDownloadStatus,
  classes,
  handleClick,
  isFilterDropDownOpen,
  resource,
  selected,
  status
}) => {
  if ((status === DOWNLOAD_STATUS_INPROGRESS || status === DOWNLOAD_STATUS_DELETING) &&
  (bulkDownloadStatus === BULK_DOWNLOAD_STATUS_INPROGRESS || bulkDownloadStatus === BULK_DOWNLOAD_STATUS_REMOVING)
  && selected) {
    return <CircularProgress className={classes.circularProgress} />;
  } if (status === DOWNLOAD_STATUS_COMPLETED && bulkDownloadStatus !== BULK_DOWNLOAD_STATUS_COMPLETED
    && bulkDownloadStatus !== BULK_DOWNLOAD_STATUS_NOT_STARTED && selected) {
    return (
      <span className={classes.selectedSpan}>
        <Icon
          color="inherit"
          name="Right"
          size="small"
        />
      </span>);
  } if (status === DOWNLOAD_STATUS_ERROR && bulkDownloadStatus !== BULK_DOWNLOAD_STATUS_COMPLETED
    && bulkDownloadStatus !== BULK_DOWNLOAD_STATUS_NOT_STARTED && selected) {
    return (
      <span className={classes.selectedSpan}>
        <Icon
          color="error"
          name="Warning"
          size="small"
        />
      </span>);
  }

  return (<StyledCheckBox
    checked={selected}
    disabled={isFilterDropDownOpen || ResourceUtils.isBulkDownloadInProgress(bulkDownloadStatus)}
    onClick={event => handleClick(event, resource)}
  />);
};

StatusIcon.propTypes = {
  bulkDownloadStatus: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
  isFilterDropDownOpen: PropTypes.bool,
  resource: PropTypes.object,
  selected: PropTypes.bool,
  status: PropTypes.string
};

StatusIcon.defaultProps = {
  handleClick: () => { },
  isFilterDropDownOpen: false,
  resource: {},
  selected: false,
  status: ''
};

export default withStyles(styles)(StatusIcon);

